import React, { useEffect, useState } from "react";
import { Container, Typography } from "@material-ui/core";
import { Grid } from "@mui/material";
import FakeData from "../FakeData/FakeDaa.json";
import "./Projects.css";
import ProjectDetails from "../ProjectDetails/ProjectDetails";

const Projects = () => {
  const [data, setData] = useState([]);
  const [another, setAnother] = useState(true);
  const anotherData = () => {
    setAnother(!another);
    console.log("clicked");
  };
  console.log(data);
  useEffect(() => {
    setData(another === true ? FakeData.slice(0, 6) : FakeData);
  }, [another]);
  return (
    <>
      <Container className="project-container">
        {/* <div className="project-heading">
          <Typography variant="h4">
            All Of My&nbsp;<span>Work</span>{" "}
          </Typography>
        </div> */}
        <div
          className="project-heading"
          style={{ display: "flex", justifyContent: "center" }}
        >
          <div>
            <Typography variant="h4" style={{ color: "#ff0266" }}>
              {" "}
              All Of My&nbsp;<span>Work</span>
            </Typography>
            <div
              style={{
                borderBottom: "2px solid #fff",
                display: "flex",
                justifyContent: "center",
              }}
            ></div>
          </div>
        </div>
        <br />
        <br />
        <br />
        <br />
        <Grid item container spacing={3}>
          {data.map((fd) => (
            <ProjectDetails key={fd._id} projects={fd} />
          ))}
        </Grid>
        <br />
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: "10em",
          }}
        >
          <button
            className={another === false ? "hideButton" : "btn draw-border"}
            onClick={anotherData}
          >
            see more
          </button>
        </div>
      </Container>
    </>
  );
};

export default Projects;
